import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

type OpenLinkProps = {
  color?: keyof typeof COLORS;
  size?: number;
};

const OpenLink = ({ color = "lightblack", size }: OpenLinkProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "20"}
      height={size ? size : "20"}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.33301 3.3335H4.99967C4.0792 3.3335 3.33301 4.07969 3.33301 5.00016V15.0002C3.33301 15.9206 4.0792 16.6668 4.99967 16.6668H14.9997C15.9201 16.6668 16.6663 15.9206 16.6663 15.0002V11.6668M9.99967 10.0002L16.6663 3.3335M16.6663 3.3335V7.50016M16.6663 3.3335H12.4997"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OpenLink;
